import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import I18n from "../i18n.js";

const blockStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${theme.palette.grayText}`,
    padding: "24px 66px",
    textAlign: "center",
    fontSize: "14px",
    lineHeight: "20px",
    ['@media (max-width: 768px)']: {
      padding: "13px 12px 17px",
    },
  },
  title: {
    fontSize: "20px !important",
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: "24px !important",
    marginTop: "0",
    marginBottom: "15px",
    textTransform: "uppercase",
    color: `${theme.palette.grayText} !important`,
    ['@media (max-width: 768px)']: {
      marginBottom: "8px !important",
      fontSize: "12px !important",
      lineHeight: "16px !important"
    },
  },
  text: {
    display: "block",
    color: `${theme.palette.grayText} !important`,
    ['@media (max-width: 768px)']: {
      fontSize: "10px",
      lineHeight: "14px"
    },
  }
}));

const DisclaimerBlock =  (props) => {

  const classes = blockStyles();
  const { className } = props;
  return (
    <div className = { clsx(classes.root, className) } >
      <div className = { classes.title }>
        { I18n.t("web.page.project.disclaimer.title") }
      </div>
      <span className = { classes.text } >
        { I18n.t("web.page.project.disclaimer.text") }
      </span>
    </div>
  );
}

export default DisclaimerBlock;